export default __webpack_public_path__ + "images/Cuban.7c3d4a.jpg";